import React from 'react';

const Imprint = () => (
  <div style={{ padding: '0 15px' }}>
    <p>
      <b>BIWAPP ist ein Produkt der </b> <br />
      Marktplatz GmbH <br />
      Agentur für Web & App <br />
      Geschäftsführer Frank Dalock <br />
      Stresemannstr. 6 <br />
      21335 Lüneburg <br />
      <br />
      Tel.: <a href="tel:041317899000">04131 789900-0</a>
      <br />
      Fax: <a href="tel:041317899009">04131 789900-9</a>
      <br />
      E-Mail: <a href="mailto:info@marktplatz-agentur.de">info@marktplatz-agentur.de</a> <br />
      Internet: <a href="http://www.marktplatz-agentur.de">www.marktplatz-agentur.de</a>
    </p>
    <p>
      Handelsregister Lüneburg: HRB 2053 <br />
      USt-IdNr.: DE206034257
    </p>
    <p>
      Die Meldungen und Katastrophenwarnungen unterliegen der Verantwortung des Versenders, welcher
      in der Meldung gekennzeichnet ist.
    </p>
    <p>
      BIWAPP ersetzt nicht die Anweisungen von Polizei, Feuerwehr oder anderen Einsatzkräften vor
      Ort. <br />
      Gewährleistungs- und Haftungsansprüche jeglicher Art durch die Nutzung von BIWAPP werden
      ausgeschlossen.
    </p>
  </div>
);

export default Imprint;



// WEBPACK FOOTER //
// ./src/js/routes/Information/Imprint.js